'use client';

// Client-only: cfLoader passes a function to next/image.
import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';

export function TimelineImages({
  desktopImage,
  mobileImage,
}: {
  desktopImage?: ImageStrapiProps;
  mobileImage?: ImageStrapiProps;
}) {
  return (
    <>
      <div className='max-[481px]:hidden'>
        <ImageStrapi
          block={{ ...desktopImage }}
          inner={{
            classNames: { image: 'h-full w-full' },
            cfLoader: 'timelineLarge',
          }}
        />
      </div>
      <div className='hidden max-[481px]:block'>
        <ImageStrapi
          block={{ ...mobileImage }}
          inner={{
            classNames: { image: 'h-full w-full' },
            cfLoader: 'timelineSmall',
          }}
        />
      </div>
    </>
  );
}
